import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { logout } from '~/auth/slices/auth.slice'
import { REWARD_FEATURE } from '~/gamification/types/gamification.types'
import { RootState } from '~/redux/store'

interface FeatureImage {
  alt: string
  srcKey: string
}

interface ChecklistState {
  rewardFeature: REWARD_FEATURE | null
  featureImage?: FeatureImage | null
}

const initialState: ChecklistState = {
  rewardFeature: null,
  featureImage: null,
}

const slice = createSlice({
  name: 'checklist',
  initialState,
  reducers: {
    setChecklistNotification(state, { payload }: PayloadAction<ChecklistState>) {
      state.rewardFeature = payload.rewardFeature
      state.featureImage = payload.featureImage
    },
    unsetChecklistNotification(state) {
      state.rewardFeature = null
      state.featureImage = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => {
      return initialState
    })
  },
})

export const getChecklistNotification = (state: RootState): REWARD_FEATURE | null => state.checklist?.rewardFeature

export const getChecklistFeatureImage = (state: RootState): FeatureImage | null => state.checklist?.featureImage || null

// ACTIONS
export const { setChecklistNotification, unsetChecklistNotification } = slice.actions

export default slice.reducer
